export default __webpack_public_path__ + "static/media/RosanaRodrigues_05.9ed5a833.jpg";